import { AnyIfEmpty } from "react-redux";
import { GET_PERMISSION_LIST_FAILURE, GET_PERMISSION_LIST_REQUEST, GET_PERMISSION_LIST_SUCCESS } from "../constats/permissions.constants";
import axios, { AxiosResponse } from "axios";
import { Module, TransformedPermissionsData } from "../../../components/roles/rolePermission/RolePermission";

const getPermissionsListSuccess = (permissionList: AnyIfEmpty<object>) => {
    return {
        type: GET_PERMISSION_LIST_SUCCESS,
        payload: permissionList,
    };
};

const getPermissionsListFailure = (error: AnyIfEmpty<object>) => {
    return {
        type: GET_PERMISSION_LIST_FAILURE,
        payload: error,
    };
};

const getPermissionsListRequest = () => {
    return {
        type: GET_PERMISSION_LIST_REQUEST,
    };
};

export const getPermissionfromRoleId = (id: string) => {
    return (dispatch: AnyIfEmpty<object>) => {
        dispatch(getPermissionsListRequest())
        axios.get(`/roles/modules-permissions/${id}`)
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 200) {
                    dispatch(getPermissionsListSuccess(response?.data));
                } else {
                    dispatch(getPermissionsListFailure(response?.data?.message))
                }
            }).catch((error) => {
                dispatch(getPermissionsListFailure(error?.response?.data?.message))
            });
    };
};


export const updatePermissionsById = (id: string, permissionsData: TransformedPermissionsData, onSuccess: (message: string) => void, onFailure: (message: string) => void) => {
    return (dispatch: AnyIfEmpty<object>) => {
        axios.post(`/roles/assign-modules-permissions/`, {
            roleId: id,
            modulePermissions: permissionsData
        }).then((response: AxiosResponse) => {
            if (response.data.statusCode === 200) {
                onSuccess(response?.data?.message)
            } else {
                onFailure(response?.data?.message)
            }
        }).catch((error) => {
            onFailure(error?.response?.data?.message)
        });
    };
};

